<template>
    <div v-if="visible" class="EvieChatThinking" aria-label="Evie is thinking">
        <span class="EvieChatThinking__dot" />
        <span class="EvieChatThinking__dot" />
        <span class="EvieChatThinking__dot" />
    </div>
</template>

<style lang="scss">
@keyframes evie-pulse {
    0%, 80%, 100% {
        opacity: 0.2;
        transform: scale(0.8);
    }

    40% {
        opacity: 1;
        transform: scale(1);
    }
}

.EvieChatThinking {
    display: flex;
    gap: 4px;
    padding: 12px 16px;

    &__dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: var(--eidSecureBlue);
        animation: evie-pulse 1.2s infinite ease-in-out;

        &:nth-child(1) {
            animation-delay: 0s;
        }

        &:nth-child(2) {
            animation-delay: 0.2s;
        }

        &:nth-child(3) {
            animation-delay: 0.4s;
        }
    }
}
</style>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        name: 'EvieChatThinking',
        props: {
            visible: { type: Boolean, required: true },
        },
    });
</script>
